<div class="alert alert-info" style="max-width: 400px;margin: 40px auto;text-align: center;font-weight: 600;">
    <h5 style="font-weight: 600;">
       <i class="fas fa-info" aria-hidden="true"></i> Em Desenvolvimento
    </h5>
    <p class="m-0">Funcionalidade em desenvolvimento</p>
</div>